import { Dokument } from './dokument';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseContainer, TabsContainerService, BaseTabsContainer, UserService } from 'yt-ng-framework';

@Component({
  selector: 'yt-dokument-tabs',
  templateUrl: './dokument-tabs.component.html',
  providers: [
    TabsContainerService
  ]
})
export class DokumentTabsComponent
 extends BaseTabsContainer<Dokument>
  implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<Dokument>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService
  ) {
    super(tabsContainerService, activatedRoute, userService);
   }

  ngOnInit() {
    super.ngOnInit();
  }

}
